// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Template4_pageWrapper__7m3pj","sidebar":"Template4_sidebar__ZN41i","mainContent":"Template4_mainContent__SqFui"};